import React from "react";
import FilledButton from "../SelectButton/FilledButton";
import EmptyButton from "../SelectButton/EmptyButton";

const RadioGroup = ({
  heading,
  name,
  radioBtnArray,
  handleChange,
  handleChangeReturnEvent,
  value,
  containerClass,
  radioBtnWrapperClass,
  radioBtnsPerRow,
  isLoading = false,
  children,
  groupId = "",
  groupName = "",
  isDisabled = false,
}) => {
  return (
    <div className="radio_group_container">
      <h2 id={groupId} className="radio_group_heading">
        {heading}
      </h2>
      <div
        role="radiogroup"
        aria-labelledby={groupId}
        className={containerClass || "all_radio_btns"}
        style={{ "--columns": radioBtnsPerRow || 8 }}
        aria-disabled={isDisabled}
      >
        {!isLoading
          ? radioBtnArray?.map((radioBtnData) => (
              <label
                key={radioBtnData.value}
                className={`custom-radio ${
                  radioBtnWrapperClass || "radio_btn_wrapper"
                }`}
              >
                <input
                  type="radio"
                  name={groupName}
                  value={radioBtnData.value}
                  checked={value === radioBtnData.value}
                  onChange={() => {
                    if (handleChangeReturnEvent) {
                      handleChange(radioBtnData);
                    } else {
                      handleChange(radioBtnData.value);
                    }
                  }}
                  disabled={isDisabled}
                />

                <span className="radio-ui radio_btn_input" aria-hidden="true">
                  {radioBtnData.value === value ? (
                    <FilledButton />
                  ) : (
                    <EmptyButton />
                  )}
                </span>

                <span
                  className="radio_btn_label"
                  // for={radioBtnData.value}
                  style={{ cursor: "pointer" }}
                >
                  {radioBtnData?.title}
                </span>
              </label>
            ))
          : children}
      </div>
    </div>
  );
};

export default RadioGroup;
